import React, {type CSSProperties, type ReactElement, useMemo} from 'react';
import {FixedSizeList as List} from 'react-window';

type RenderItemProps<ItemType> = {
  index: number;
  style: CSSProperties;
  data: {
    items: readonly ItemType[];
    renderItem: (item: ItemType, style: CSSProperties) => ReactElement;
  };
};

function RenderItem<ItemType>(props: RenderItemProps<ItemType>) {
  const {
    index,
    style,
    data: {items, renderItem},
  } = props;
  const item = items[index];

  return renderItem(item, style);
}

type ImportPanelListProps<ItemType> = {
  ['data-test']?: string;
  items: readonly ItemType[];
  itemSize: number;
  height: number;
  width: number;
  renderItem: (item: ItemType, style: CSSProperties) => ReactElement;
};

export function ImportPanelList<ItemType>(
  props: ImportPanelListProps<ItemType>
) {
  const itemData = useMemo(
    () => ({
      items: props.items,
      renderItem: props.renderItem,
    }),
    [props.items, props.renderItem]
  );

  return (
    <div data-test={props['data-test']}>
      <List
        height={props.height}
        itemCount={props.items.length}
        width={props.width}
        itemSize={props.itemSize}
        itemData={itemData}>
        {RenderItem<ItemType>}
      </List>
    </div>
  );
}
